module.exports = __webpack_public_path__ + "img/icon_slider_button.691bb72d.png";